import { useDispatch, useSelector } from "react-redux";
import LeaveComponent from "../LeaveComponent";
import { genericHeaders, serviceUrl } from "../../utils/apiConfig";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../customComponents/customLoader";
import { useEffect, useState } from "react";
import { useGetLeaveTypesQuery } from "../../api/getLeaveTypeApi";
import { useLazyGetDashBoardReviewsQuery } from "../../api/allReviewsAPI";
import { setDashBoardReviewData } from "../../store/reducers/dashboardReviewsSlice";
import NoContent from '../../Icons/No-Content-Laptop.svg'  

const AdminReviewLeavs = () => {
  const [loading, setLoading] = useState(false);
  const [visibleDetails, setVisibleDetails] = useState({});
  const dispatch = useDispatch();
  const dashboardLeavesData = useSelector(
    (state) => state.dashBoardReview?.pendingleaves
  );
  const [getDashBoardLeaves, { data: leavesData }] =
    useLazyGetDashBoardReviewsQuery({});
  const { data: leavesTypes } = useGetLeaveTypesQuery({});
  const [leaveData, setLeavesData] = useState([]);

  const toggleDetailsVisibility = (id, forceValue = null) => {
    setVisibleDetails(prev => ({
      ...prev,
      [id]: forceValue !== null ? forceValue : !prev[id]
    }));
  };
  const cleanupVisibilityState = (id) => {
    setVisibleDetails(prev => {
      const newState = { ...prev };
      delete newState[id];
      return newState;
    });
  };

  const handleApprove = async (transId) => {
    setLoading(true);
    try {
      let response = await axios.put(
        `${serviceUrl}/api/leaveTransaction/leaveAccepted?leaveTransactionId=${transId}`,
        null,
        { headers: genericHeaders() }
      );
      if (response.status === 204) {
        setLoading(false);
        cleanupVisibilityState(transId);
        getDashBoardLeaves();
        toast.success("Leave Approved Successfully");
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something Went Wrong");
      console.error(err);
    }
  };

  const handleReject = async (transId) => {
    setLoading(true);
    try {
      let response = await axios.put(
        `${serviceUrl}/api/leaveTransaction/leaveRejected?leaveTransactionId=${transId}`,
        null,
        { headers: genericHeaders() }
      );
      if (response.status === 204) {
        cleanupVisibilityState(transId);
        getDashBoardLeaves();
        toast.success("Leave Rejected Successfully");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something Went Wrong");
      console.error(err);
    }
  };

  const renderLeavesComponent = () => {
    return dashboardLeavesData?.map((each) => {
      const leaveCategory = leaveData?.find(
        (eachLeave) => eachLeave._id === each.leaveType
      );
      const props = {
        ...each,
        role: "Manager",
        button: "Approve",
        leaveCategory: leaveCategory?.leaveCategory
          ? leaveCategory.leaveCategory
          : "",
      };
      return (
        <LeaveComponent
          key={each._id}
          data={props}
          detailsVisible={visibleDetails[each._id] || false}
          toggleDetailsVisibility={toggleDetailsVisibility}
          approve={handleApprove}
          reject={handleReject}
        />
      );
    });
  };

  useEffect(() => {
    setLeavesData(leavesTypes);
  }, [leavesTypes]);

  useEffect(() => {
    if (leavesData?.data) {
      dispatch(setDashBoardReviewData(leavesData.data));
    }
  }, [leavesData]);

  useEffect(() => {
    if (dashboardLeavesData) {
      const currentIds = dashboardLeavesData.map(item => item._id);
      setVisibleDetails(prev => {
        const newState = {};
        Object.keys(prev).forEach(id => {
          if (currentIds.includes(id)) {
            newState[id] = prev[id];
          }
        });
        return newState;
      });
    }
  }, [dashboardLeavesData]);

  return (
    <>
      {loading && <Loader />}
      <div className="flex flex-col rounded-md font-medium mr-[3%] ">
        {dashboardLeavesData?.length === 0 
        ? 
        ((
          <div className="mt-[15%] flex flex-col items-center justify-center">
            <img src={NoContent} alt="No Content"/>
            <p className='text-xl'>There are no pending records of any leave transaction</p>
          </div>
        ))
        :
        (renderLeavesComponent())}
      </div>
    </>
  );
};

export default AdminReviewLeavs;